import { grades } from "data/grades";

const EXCLUDED_GRADE_VALUES = new Set(["HigherEd", "Gov"]);
const EDUCATOR_ONLY_ROLES = new Set(["Teacher", "OrganizationAdmin"]);

function getBaseGradeOptions() {
  return grades.filter((grade) => !EXCLUDED_GRADE_VALUES.has(grade.value));
}

export function getAllowedGradesForRole(role, isHigherEd = false, isGov = false) {
  if (isGov) {
    return grades.filter((g) => g.value === "Gov");
  }

  if (isHigherEd) {
    if (role === "Student") {
      return grades.filter((g) => g.value === "HigherEd");
    }
    return grades.filter((g) => g.value === "Educator");
  }

  const baseGrades = getBaseGradeOptions();

  if (role === "Student") {
    return baseGrades.filter((grade) => grade.value !== "Educator");
  }

  if (EDUCATOR_ONLY_ROLES.has(role)) {
    return baseGrades.filter((grade) => grade.value === "Educator");
  }

  return baseGrades;
}

export function getFormikGradeOptionsForRole(role, isHigherEd = false, isGov = false) {
  return getAllowedGradesForRole(role, isHigherEd, isGov).map((grade) => ({
    key: grade.value,
    label: grade.label,
  }));
}

export function getGridGradeOptionsForRole(role, isHigherEd = false, isGov = false) {
  return getAllowedGradesForRole(role, isHigherEd, isGov).map((grade) => ({
    value: grade.value,
    label: grade.label,
  }));
}

export function getDefaultGradeLevelForRole(role, isHigherEd = false, isGov = false) {
  if (isGov) {
    return "Gov";
  }

  if (isHigherEd) {
    return role === "Student" ? "HigherEd" : "Educator";
  }

  if (EDUCATOR_ONLY_ROLES.has(role)) {
    return "Educator";
  }

  return "";
}

export function isGradeAllowedForRole(role, gradeLevel, isHigherEd = false, isGov = false) {
  if (!gradeLevel) {
    return true;
  }

  return getAllowedGradesForRole(role, isHigherEd, isGov).some(
    (grade) => grade.value === gradeLevel
  );
}
